import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useAuthStore } from '../store/authStore';
import { BalancePill } from '../components/BalancePill';

const links = [
  { to: '/', label: 'Lobby', end: true },
  { to: '/games/slot', label: 'Slots' },
  { to: '/games/roulette', label: 'Roulette' },
  { to: '/games/blackjack', label: 'Blackjack' },
  { to: '/wallet', label: 'Wallet' },
];

export function PlayerLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const role = useAuthStore((s) => s.role);

  const onLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-felt-dark">
      <header className="sticky top-0 z-40 border-b border-white/10 bg-felt/95 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center gap-4 px-4 py-3">
          <NavLink to="/" className="text-lg font-bold text-gold">
            ♠ Royal Tokens
          </NavLink>
          <nav className="hidden gap-1 sm:flex">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-1.5 text-sm font-medium ${
                    isActive ? 'bg-gold text-felt-dark' : 'text-slate-300 hover:bg-white/10'
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-3">
            <BalancePill />
            {role === 'admin' && (
              <NavLink to="/admin" className="btn-ghost px-3 py-1.5 text-sm">
                Admin
              </NavLink>
            )}
            <NavLink to="/profile" className="text-slate-300 hover:text-gold" title="Profile">
              ⚙
            </NavLink>
            <button onClick={onLogout} className="btn-ghost px-3 py-1.5 text-sm">
              Log out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
